import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type {
  AgentChatSummary,
  PreviewUser,
} from '@/features/proactive-agents/proactive-agents-types';

const describeChat = (chat: AgentChatSummary) =>
  chat.deleted ? 'deleted' : chat.state;

// `users` are the first of `userCount` matching users by email, as many as the server sends
export const UserPreviewTable = ({
  agent,
  users,
  userCount,
}: {
  agent: string;
  users: PreviewUser[];
  userCount: number;
}) => (
  <>
    <Table containerClassName="max-h-96 rounded-md border">
      <TableHeader>
        <TableRow>
          <TableHead>Email</TableHead>
          <TableHead>Internal</TableHead>
          <TableHead>Default agent</TableHead>
          <TableHead>Chats of {agent}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.user_id}>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.is_internal ? 'Yes' : 'No'}</TableCell>
            <TableCell>
              <div className="flex flex-wrap items-center gap-2">
                {user.default_agent}
                {user.default_is_override ? (
                  <Badge variant="secondary">override</Badge>
                ) : null}
              </div>
            </TableCell>
            <TableCell>
              {user.agent_chats.length
                ? user.agent_chats.map(describeChat).join(', ')
                : 'none'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    {userCount > users.length ? (
      <p className="text-muted-foreground">
        The table shows the first {users.length.toLocaleString()} users by
        email.
      </p>
    ) : null}
  </>
);
